<template>
    <div>
        <!-- Description -->
        <div class="card shadow-none">
            <div class="card-body">
                <!-- tl-wrapper -->
                <div class="tl-wrapper">
                    <div class="tl-l">
                        <div class="avatar-xs">
                            <span class="avatar-title rounded bg-soft-primary text-primary font-size-16">
                               {{ $auth.user.name.charAt(0) }}
                            </span>
                        </div>
                    </div>
                    <div class="tl-r">
                        <div class="btn-group mr-2">
                            <button type="button" class="btn btn-itg" @click="selectAction('reply')">
                                <i class="fa fa-reply mr-1"></i> Reply
                            </button>
                        </div>
                        <div class="btn-group mr-2">
                            <button type="button" class="btn btn-itg" @click="selectAction('add-note')">
                                <i class="fa fa-pencil-alt mr-1"></i> Add note
                            </button>
                        </div>
                        <div class="btn-group mr-2">
                            <button type="button" class="btn btn-itg" @click="selectAction('forward-ticket')">
                                <i class="fa fa-reply fa-flip-horizontal mr-1"></i> Forward
                            </button>
                        </div>
                        <div class="btn-group">
                            <button type="button" class="btn btn-itg" @click="selectAction('send-sms')">
                                <i class="fa fa-comment-dots mr-1"></i> Send SMS
                            </button>
                        </div>
                    </div>
                </div>
                <!-- / tl-wrapper -->
            </div>
        </div>
        <!-- / Description -->

    </div>
</template>

<script>
    import {mapGetters, mapActions} from "vuex";
    import PhoneIcon from "../../../../../components/icons/PhoneIcon";

    export default {
        name: "TicketActions",
        computed: {
            ...mapGetters('ticketViewer', {
                ticket: 'ticket'
            })
        },
        methods: {
            ...mapActions('ticketViewer', {
                selectAction: 'selectAction'
            })
        },
        components: {PhoneIcon}
    }
</script>

<style scoped>
    .card {
        background-color: #f5f7f9;
    }

    .card-body {
        padding-top: 11px !important;
        padding-bottom: 11px !important;
    }
</style>
